import { useDispatch } from "react-redux";

import { ActionTypes } from "../store/types";
import scss from "./CharacterCard.module.scss";

export const CharacterCard = ({ character, selectedCharacters }) => {
  const { id, name, selected, deselected } = character;
  const isSelected = selectedCharacters.indexOf(id) > -1;
  const dispatch = useDispatch();

  const handleSelect = () => {
    if (isSelected) {
      dispatch({
        type: ActionTypes.DESELECT_CHARACTER,
        payload: { id },
      });
    } else if (selectedCharacters.length < 4) {
      dispatch({
        type: ActionTypes.SELECT_CHARACTER,
        payload: { id },
      });
    } else if (selectedCharacters.length === 4) {
      dispatch({
        type: ActionTypes.SELECT_CHARACTER,
        payload: { id },
      });
      dispatch({
        type: ActionTypes.SET_MODAL,
        payload: {
          open: true,
          template: "CONFIRM_SQUAD_SUBMIT",
        },
      });
    } else {
      dispatch({
        type: ActionTypes.SET_MODAL,
        payload: {
          open: true,
          message: "Only 5 characters allowed!",
        },
      });
    }
  };

  const selectionStyles = {
    color: isSelected ? "#418BFA" : "#ffffff",
    borderColor: isSelected ? "#418BFA" : "#ffffff",
  };

  return (
    <div className={scss.CharacterCard} onClick={handleSelect}>
      <div className={scss.imgWrapper}>
        <img
          src={isSelected ? selected : deselected}
          alt={name}
          className={scss.characterImage}
        />
      </div>
      <button className="roundedButton" style={selectionStyles}>
        {isSelected ? "SELECTED" : "SELECT"}
      </button>
    </div>
  );
};
